import { createFileRoute } from '@tanstack/react-router'
import { NavyShipDatabase } from 'pages/shipDatabase/NavyShipDatabase'
import z from 'zod'

const navyShipDBSearchSchema = z.object({
  name: z.string().optional(),
  class: z.array(z.string()).optional(),
  fleet: z.array(z.string()).optional(),
  homeport: z.array(z.string()).optional(),
  commissionDate: z.array(z.string()).optional(),
  lastInspectionDate: z.array(z.string()).optional(),
  search: z.string().optional(),
})

export const Route = createFileRoute('/ships/$siteID')({
  component: RouteComponent,
  staticData: {
    title: 'Ships',
  },
  validateSearch: navyShipDBSearchSchema,
})

function RouteComponent() {
  return (
    <>
      <NavyShipDatabase />
    </>
  )
}
